import React, { useState, useEffect } from "react";

const TeamsEditStep = ({ csvData, validationErrors, handleUpdateCsvData }) => {
  const [editedData, setEditedData] = useState([]);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    setEditedData(csvData);
    setErrors(validationErrors);
  }, [csvData, validationErrors]);

  const totalErrorRows = errors.filter(
    (error) => error && error.errors.length > 0
  ).length;

  const formatKey = (key) =>
    key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  const expectedColumns = [
    "first_name",
    "last_name",
    "emp_id",
    "phone",
    "L1_first_name",
    "L1_last_name",
    "L1_emp_id",
    "L1_phone",
    "L2_first_name",
    "L2_last_name",
    "L2_emp_id",
    "L2_phone",
  ];

  const isIncorrectFormat = errors.some((error) => {
    return !error.data || !expectedColumns.every((key) => key in error.data);
  });

  return (
    <div className="editcontianer">
      <h3>Total Error Rows: {totalErrorRows}</h3>

      {isIncorrectFormat && (
        <div className="format-error">
          <h4>⚠️ Incorrect CSV Format Detected</h4>
          <p>
            The uploaded CSV does not match the expected format for team
            hierarchy upload.
          </p>
          <div className="format-guide">
            <p>Expected CSV format for Team Hierarchy Upload:</p>
            <ul>
              <li>first_name: Letters and spaces only</li>
              <li>last_name: Letters and spaces only</li>
              <li>emp_id: Employee ID</li>
              <li>phone: Employee Phone</li>
              <li>L1_first_name: Letters and spaces only (L1 Manager)</li>
              <li>L1_last_name: Letters and spaces only (L1 Manager)</li>
              <li>L1_emp_id: L1 Manager Employee ID</li>
              <li>L1_phone: L1 Manager Phone</li>
              <li>L2_first_name: Letters and spaces only (L2 Manager)</li>
              <li>L2_last_name: Letters and spaces only (L2 Manager)</li>
              <li>L2_emp_id: L2 Manager Employee ID</li>
              <li>L2_phone: L2 Manager Phone</li>
            </ul>
          </div>
          <div className="uploaded-data">
            <p>Your uploaded data:</p>
            <pre>{JSON.stringify(errors[0]?.data || {}, null, 2)}</pre>
          </div>
        </div>
      )}

      {!isIncorrectFormat && (
        <>
          <div
            className="editstep-table-wrapper"
            role="region"
            aria-live="polite"
          >
            <table>
              <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Employee ID</th>
                  <th>Phone</th>
                  <th>L1 First Name</th>
                  <th>L1 Last Name</th>
                  <th>L1 Employee ID</th>
                  <th>L1 Phone</th>
                  <th>L2 First Name</th>
                  <th>L2 Last Name</th>
                  <th>L2 Employee ID</th>
                  <th>L2 Phone</th>
                  <th>Reason of Failure</th>
                </tr>
              </thead>
              <tbody>
                {errors.map((error, index) => (
                  <tr className="trcontainer" key={index}>
                    <td
                      className={
                        error.errors.some((err) =>
                          err.toLowerCase().includes("first name")
                        )
                          ? "errorMessage"
                          : ""
                      }
                    >
                      {error?.data?.first_name}
                    </td>
                    <td
                      className={
                        error.errors.some((err) =>
                          err.toLowerCase().includes("last name")
                        )
                          ? "errorMessage"
                          : ""
                      }
                    >
                      {error?.data?.last_name}
                    </td>
                    <td
                      className={
                        error.errors.some((err) =>
                          err.toLowerCase().includes("employee id")
                        )
                          ? "errorMessage"
                          : ""
                      }
                    >
                      {error?.data?.emp_id}
                    </td>
                    <td
                      className={
                        error.errors.some((err) =>
                          err.toLowerCase().includes("phone")
                        )
                          ? "errorMessage"
                          : ""
                      }
                    >
                      {error?.data?.phone}
                    </td>
                    <td
                      className={
                        error.errors.some((err) =>
                          err.toLowerCase().includes("l1 first name")
                        )
                          ? "errorMessage"
                          : ""
                      }
                    >
                      {error?.data?.L1_first_name}
                    </td>
                    <td
                      className={
                        error.errors.some((err) =>
                          err.toLowerCase().includes("l1 last name")
                        )
                          ? "errorMessage"
                          : ""
                      }
                    >
                      {error?.data?.L1_last_name}
                    </td>
                    <td
                      className={
                        error.errors.some((err) =>
                          err.toLowerCase().includes("l1 employee id")
                        )
                          ? "errorMessage"
                          : ""
                      }
                    >
                      {error?.data?.L1_emp_id}
                    </td>
                    <td
                      className={
                        error.errors.some((err) =>
                          err.toLowerCase().includes("l1 phone")
                        )
                          ? "errorMessage"
                          : ""
                      }
                    >
                      {error?.data?.L1_phone}
                    </td>
                    <td
                      className={
                        error.errors.some((err) =>
                          err.toLowerCase().includes("l2 first name")
                        )
                          ? "errorMessage"
                          : ""
                      }
                    >
                      {error?.data?.L2_first_name}
                    </td>
                    <td
                      className={
                        error.errors.some((err) =>
                          err.toLowerCase().includes("l2 last name")
                        )
                          ? "errorMessage"
                          : ""
                      }
                    >
                      {error?.data?.L2_last_name}
                    </td>
                    <td
                      className={
                        error.errors.some((err) =>
                          err.toLowerCase().includes("l2 employee id")
                        )
                          ? "errorMessage"
                          : ""
                      }
                    >
                      {error?.data?.L2_emp_id}
                    </td>
                    <td
                      className={
                        error.errors.some((err) =>
                          err.toLowerCase().includes("l2 phone")
                        )
                          ? "errorMessage"
                          : ""
                      }
                    >
                      {error?.data?.L2_phone}
                    </td>
                    <td className="error-messages">
                      {error.errors.join(",\n")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="editstep-card-list">
            {errors.map((error, index) => (
              <article className="editstep-card" key={`teams-card-${index}`}>
                <header className="editstep-card__header">
                  <span className="editstep-card__row-label">
                    Row{" "}
                    {typeof error.index === "number"
                      ? error.index + 1
                      : index + 1}
                  </span>
                </header>
                <dl className="editstep-card__details">
                  {Object.entries(error?.data || {}).map(([key, value]) => (
                    <div className="editstep-card__detail" key={key}>
                      <dt>{formatKey(key)}</dt>
                      <dd>
                        {value !== undefined && value !== "" ? value : "—"}
                      </dd>
                    </div>
                  ))}
                </dl>
                <div className="editstep-card__errors">
                  <h4>Issues</h4>
                  <ul>
                    {error.errors.map((err, errIndex) => (
                      <li key={errIndex}>{err}</li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default TeamsEditStep;
